import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1302Storno1RestantStatus: 'idle',
    startProcess1302Storno1RestantError: undefined as any,
    loadUserParamsProcess1302Storno1RestantStatus: 'idle',
    loadUserParamsProcess1302Storno1RestantError: undefined as any,

    process1302Storno1RestantList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1302Storno1Restant = createAsyncThunk('process1302Storno1RestantSlice/startProcess1302Storno1Restant', async ({ process1302Storno1Restant }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1302Storno1Restant/`,
        prepareData(process1302Storno1Restant),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1302Storno1RestantStatus } = getState().process1302Storno1RestantSlice
        return startProcess1302Storno1RestantStatus !== 'pending'
    }
})

export const loadUserParamsProcess1302Storno1Restant = createAsyncThunk('process1302Storno1RestantSlice/loadUserParamsProcess1302Storno1Restant', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1302Storno1Restant/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1302Storno1RestantStatus } = getState().process1302Storno1RestantSlice
        return loadUserParamsProcess1302Storno1RestantStatus !== 'pending'
    }
})

const Process1302Storno1RestantSlice = createSlice({
    name: 'process1302Storno1RestantSlice',
    initialState,
    reducers: {
        resetstartProcess1302Storno1Restant: (state) => {
            state.job = undefined
            state.startProcess1302Storno1RestantError = undefined
        },
        resetstartProcess1302Storno1RestantError: (state) => {
            state.startProcess1302Storno1RestantError = undefined
        },
        resetloadUserParamsProcess1302Storno1Restant: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1302Storno1RestantError = undefined
        },
        resetloadUserParamsProcess1302Storno1RestantError: (state) => {
            state.loadUserParamsProcess1302Storno1RestantError = undefined
        },
        removeFromProcess1302Storno1RestantListById: (state, action) => {
            state.process1302Storno1RestantList = state.process1302Storno1RestantList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1302Storno1RestantListByIds: (state, action) => {
            state.process1302Storno1RestantList = state.process1302Storno1RestantList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1302Storno1RestantList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1302Storno1RestantStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1302Storno1RestantList = []
            state.startProcess1302Storno1RestantStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1302Storno1Restant.pending, (state) => {
            state.startProcess1302Storno1RestantStatus = 'pending'
            state.startProcess1302Storno1RestantError = undefined
        })
        builder.addCase(startProcess1302Storno1Restant.fulfilled, (state, action) => {
            state.startProcess1302Storno1RestantStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1302Storno1Restant.rejected, (state, action) => {
            state.startProcess1302Storno1RestantStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1302Storno1RestantError = action.error.message
            } else {
                state.startProcess1302Storno1RestantError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1302Storno1Restant.pending, (state) => {
            state.loadUserParamsProcess1302Storno1RestantStatus = 'pending'
            state.loadUserParamsProcess1302Storno1RestantError = undefined
        })
        builder.addCase(loadUserParamsProcess1302Storno1Restant.fulfilled, (state, action) => {
            state.loadUserParamsProcess1302Storno1RestantStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1302Storno1Restant.rejected, (state, action) => {
            state.loadUserParamsProcess1302Storno1RestantStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1302Storno1RestantError = action.error.message
            } else {
                state.loadUserParamsProcess1302Storno1RestantError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1302Storno1Restant,
    resetstartProcess1302Storno1RestantError,
    resetloadUserParamsProcess1302Storno1Restant,
    resetloadUserParamsProcess1302Storno1RestantError,
    removeFromProcess1302Storno1RestantListById,
    removeFromProcess1302Storno1RestantListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1302Storno1RestantSlice.actions
export default Process1302Storno1RestantSlice.reducer
